import _resourceService from "@/services/resources";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { DownloadData } from "./types/Resources.interface";

export const getInvoicePDF = createAsyncThunk(
  "clients/getInvoicePDF",
  async (downloadData: DownloadData) => {
    const resource = await _resourceService.getInvoicePDF(downloadData);
    return resource.fileUrl;
  },
);

export const getComercialInvoicePDF = createAsyncThunk(
  "clients/getComercialInvoicePDF",
  async (downloadData: string) => {
    const resource = await _resourceService.getResourcesPDF(downloadData);
    return resource.fileUrl;
  },
);
